import constants from '../../config'

const state = {

}

// getters
const getters = {

}

// actions
const actions = {

  async checkout({dispatch, commit}, form) {
    let endpoint = `donation/${form.campaignSlug}/checkout`
    return form.submit('post', endpoint)
  },

  async calculateApplicationFee({dispatch, commit}, form) {
    return form.submit('post', 'donation/calculate-application-fee')
  },
}


// mutations
const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}